import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

export interface ToastMessage {
  id: string;
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
  duration?: number; // Default: 3 seconds
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastsSubject = new BehaviorSubject<ToastMessage[]>([]);
  toasts$ = this.toastsSubject.asObservable();

  addToast(message: Omit<ToastMessage, 'id'>) {
    const alreadyShowing = this.toastsSubject.value.some(
      t => t.type === message.type && t.message === message.message
    );
    if (alreadyShowing) return;

    const toast: ToastMessage = { id: uuidv4(), ...message, duration: message.duration || 3000 };
    this.toastsSubject.next([...this.toastsSubject.value, toast]);

    setTimeout(() => this.removeToast(toast.id), toast.duration);
  }

  removeToast(id: string) {
    this.toastsSubject.next(this.toastsSubject.value.filter(toast => toast.id !== id));
  }
}